require('./ThumbWatchOnline.scss');

const b = require('app/www/libs/b')('thumb-watch-online', true);

const React = require('react');
const PropTypes = require('prop-types');

const Button_WatchChannelOnline = require('app/www/components/blocks/Button/_WatchChannelOnline/Button_WatchChannelOnline');
const TimeLine = require('app/www/components/blocks/TimeLine/TimeLine');

const ThumbWatchOnline = (props) => {
    const {
        className,
        image,
        channelContentId,
        finish,
        start,
        familyId,
        viewType,
        fromBlock,
    } = props;

    return (
        <div className={b.mix(className)}>
            <Button_WatchChannelOnline
                className={b('button')}
                mods={{
                    theme: 'action',
                    size: 's',
                    icon: 'bright',
                    pin: 'circle',
                    'only-icon': true,
                }}
                icon={{
                    play: true,
                    size: 's',
                }}
                familyId={familyId}
                viewType={viewType}
                fromBlock={fromBlock}
                contentId={channelContentId}
            />
            <img className={b('img')} src={image} />
            {start && (
                <TimeLine className={b('timeline')} start={start} finish={finish} />
            )}
        </div>
    );
};

ThumbWatchOnline.propTypes = {
    start: PropTypes.string,
    finish: PropTypes.string,
    className: PropTypes.string,
    image: PropTypes.string,
    channelContentId: PropTypes.string,
    familyId: PropTypes.string,
    viewType: PropTypes.string,
    fromBlock: PropTypes.string,
};

module.exports = ThumbWatchOnline;
